import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setActiveApp, setActiveView } from "src/redux/actions/app";
import { ACTIVE_APP, ACTIVE_VIEW } from "src/utils/constants";

const SelectApp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div className="flex justify-center items-center h-full w-full">
      <div className="flex flex-col gap-5">
        <div className="text-2xl font-semibold">Select APP</div>
        <div className="grid grid-cols-2 gap-3">
          <AppTile
            name="Stores"
            onClick={() => {
              // setActiveAppToLocalStorage(ACTIVE_APP.STORE);
              dispatch(setActiveApp(ACTIVE_APP.STORE));
              dispatch(setActiveView(ACTIVE_VIEW.STANDARD));
              navigate("/store/dashboard");
            }}
          />
          <AppTile
            name="Vendor"
            onClick={() => {
              // setActiveAppToLocalStorage(ACTIVE_APP.VENDOR);
              dispatch(setActiveApp(ACTIVE_APP.VENDOR));
              navigate("/vendor/dashboard");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectApp;

const AppTile = ({ name, onClick }: { name: string; onClick: () => void }) => {
  return (
    <div
      className="flex justify-center items-center p-6 rounded-xl bg-white cursor-pointer"
      onClick={onClick}
    >
      {name}
    </div>
  );
};
